export const OVERLAY_COLOR = "#F32B8B";

// During dragging we have to scale the size
// of the dot to increase its focus
export const OVERLAY_HANDLE_DOT_DRAGGING_SCALE = "1.67";
